<template>
	<svg
		width="49"
		height="48"
		viewBox="0 0 49 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="-0.666729"
			y="12.3605"
			width="25.5732"
			height="25.5732"
			rx="3.5"
			transform="rotate(-25.544 -0.666729 12.3605)"
			fill="white"
			stroke="#181818"
		/>
		<rect
			x="8.28687"
			y="20.4375"
			width="16.3822"
			height="3.27643"
			rx="1"
			transform="rotate(-25.544 8.28687 20.4375)"
			fill="#181818"
		/>
		<rect
			x="18.4377"
			y="26.4805"
			width="16.3822"
			height="3.27643"
			rx="1"
			transform="rotate(-115.544 18.4377 26.4805)"
			fill="#181818"
		/>
		<rect
			x="32.4729"
			y="0.359911"
			width="18"
			height="18"
			rx="3.5"
			transform="rotate(19.8532 32.4729 0.359911)"
			fill="white"
			stroke="#181818"
		/>
		<rect
			x="32.9366"
			y="8.89111"
			width="11.3333"
			height="2.26667"
			rx="1"
			transform="rotate(19.8532 32.9366 8.89111)"
			fill="#181818"
		/>
		<rect
			x="13.2357"
			y="32.3729"
			width="25"
			height="25"
			rx="3.5"
			transform="rotate(-49.9507 13.2357 32.3729)"
			fill="white"
			stroke="#181818"
		/>
		<rect
			x="31.1658"
			y="34.5228"
			width="5.21739"
			height="5.21739"
			rx="1"
			transform="rotate(-139.951 31.1658 34.5228)"
			fill="#181818"
		/>
	</svg>
</template>

<script>
export default {
	name: "Dices",
};
</script>
